import i18next from "i18next";

import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export async function copyToClipboard(text: string | null | undefined): Promise<boolean> {
    if (!text) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(text.trim());
        showSuccessToast(i18next.t("common:toast.copiedToClipboardSuccess"));
        return true;
    } catch (_error) {
        showErrorToast(i18next.t("common:toast.copiedToClipboardError"));
        return false;
    }
}
